import { useEffect } from 'react';
import { useNotificationPermission } from '../../hooks/useHandoffNotifications';
import {
  setNotificationsEnabled,
  useNotificationsEnabled,
} from '../../hooks/useNotificationPreference';
import { subscribeToPush, unsubscribeFromPush } from '../../services/webPush';

export function NotificationControls() {
  const { permission, request, test } = useNotificationPermission();
  const enabled = useNotificationsEnabled();

  const isOn = enabled && permission === 'granted';

  useEffect(() => {
    if (isOn) void subscribeToPush();
  }, [isOn]);

  if (permission === 'denied') {
    return (
      <span
        title="Notiser är blockerade för den här sidan — tillåt dem i webbläsarinställningarna."
        className="rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-xs font-medium text-amber-700"
      >
        Notiser blockerade
      </span>
    );
  }

  const toggle = async () => {
    if (isOn) {
      setNotificationsEnabled(false);
      await unsubscribeFromPush();
      return;
    }
    if (permission !== 'granted') {
      const result = await request();
      if (result !== 'granted') return;
    }
    setNotificationsEnabled(true);
    await subscribeToPush();
  };

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        role="switch"
        aria-checked={isOn}
        onClick={toggle}
        title={
          isOn ? 'Notiser på — klicka för att stänga av' : 'Notiser av — klicka för att slå på'
        }
        className={[
          'relative inline-flex h-6 w-11 items-center rounded-full transition',
          isOn ? 'bg-green-500' : 'bg-gray-300',
        ].join(' ')}
      >
        <span
          className={[
            'inline-block h-5 w-5 transform rounded-full bg-white shadow transition',
            isOn ? 'translate-x-5' : 'translate-x-1',
          ].join(' ')}
        />
      </button>

      <span className="text-xs font-medium text-gray-600">Notiser</span>

      {isOn && (
        <button
          type="button"
          onClick={test}
          className="rounded-lg border border-gray-300 px-2 py-1 text-xs font-medium text-gray-600 hover:bg-gray-50"
        >
          Testa
        </button>
      )}
    </div>
  );
}
